import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { FlightItem } from '@app/entities/flight-results';
import { selectFlightsAction } from '@flight-results/store/actions/flights-results.actions';
import { hashCode } from '@app/util/util';

export interface SelectedFlightsState extends EntityState<FlightItem> {}

function getId(flight: FlightItem): number {
  return hashCode(`${flight.DepartureAirport}${flight.ArrivalAirport}${flight.DepartureDate}`);
}

export const selectedFlightsAdapter: EntityAdapter<FlightItem> = createEntityAdapter<FlightItem>({
  selectId: getId
});

export const initialState: SelectedFlightsState = selectedFlightsAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(selectFlightsAction, (state, { flights }) => selectedFlightsAdapter.setAll(flights, state))
);

export function selectedFlightsReducer(state: SelectedFlightsState, action: Action): SelectedFlightsState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = selectedFlightsAdapter.getSelectors();

export const exportedForTesting = {
  getId,
};
